import {useCallback, useRef} from 'react';
import {useNavigate} from "react-router-dom";
import type {FeedbackProps} from '@yosmanyga/fortaleza-core';
import {Feedback} from '@yosmanyga/fortaleza-core';
import {BlankLayout} from "../BlankLayout.tsx";

const FeedbackScreen = () => {
    const scrollRef = useRef<HTMLDivElement>(null);

    const navigate = useNavigate();

    const handleSend = useCallback(() => {
        if (!scrollRef.current) {
            return;
        }

        scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }, []);

    const Layout = useCallback<FeedbackProps['templates']['layout']>(({story, input}) => {
        return <BlankLayout
            ref={scrollRef}
            templates={{
                footer: () => {
                    return input
                }
            }}
            onBack={() => {
                navigate(-1);
            }}
        >
            {story}
        </BlankLayout>
    }, [])

    return <Feedback
        templates={{
            layout: Layout,
        }}
        onSend={handleSend}
    />
};

export {FeedbackScreen};
